import React from 'react';

import {
  formatarMoedaIMask,
  formatarPorcentagemSufixoEsquerda,
} from '../../helpers/formatador';
import { Title } from './styles';

const tarifaPorTipo = (record, tipoTarifa) => {
  const { valor_tarifa_reais_tonelada, valor_tarifa_percentual } = record;

  return tipoTarifa === 'PERCENTUAL' ? (
    <Title className="center">
      {formatarPorcentagemSufixoEsquerda(valor_tarifa_percentual)}
    </Title>
  ) : (
    <Title className="center">
      {formatarMoedaIMask(valor_tarifa_reais_tonelada)}
    </Title>
  );
};

const getRangeTarifa = (record, currentIndex, lastIndex) => {
  const { valor_inicial, valor_final } = record;

  return currentIndex === lastIndex ? (
    <Title>{`Acima de ${formatarMoedaIMask(valor_inicial)}`}</Title>
  ) : (
    <Title>
      {`${formatarMoedaIMask(valor_inicial)} até ${formatarMoedaIMask(
        valor_final
      )}`}
    </Title>
  );
};

export const getColumns = (tipoTarifa, lastIndex) => [
  {
    title: 'Tarifa TMOV',
    key: 'valores',
    width: '60%',
    showSorterTooltip: false,
    align: 'left',
    render: (_, record, index) => getRangeTarifa(record, index, lastIndex),
  },
  {
    title: 'Tarifa por tonelada',
    key: 'valor_tarifa_percentual',
    width: '40%',
    showSorterTooltip: false,
    className: 'center',
    align: 'left',
    render: record => tarifaPorTipo(record, tipoTarifa),
  },
];
